import { get, keys, pipe, reduce } from 'lodash/fp';

export type SDLContentPath = Array<string>;
export type SDLContentMapper = (data: any) => string | string[];

export type SDLResolverSpec = Record<
  string,
  | SDLContentPath // can have only the object path of the field
  | [SDLContentPath, SDLContentMapper[]] // can have the path with an array of mappers
  | [SDLContentPath, SDLContentMapper[], string] // can have the path, the mapper array and the default value
>;

export const propOr = (
  path: string | string[],
  source: Record<string, any>,
  defaultValue = 'N/A',
) => {
  const value = get(path, source);
  return value === '' ||
    value === null ||
    value === undefined ||
    (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
    ? defaultValue
    : value;
};

export const sdlContentSpecParser = (
  infoSource: any,
  resolverSpec: SDLResolverSpec,
  globalDefaultValue = 'N/A',
) => {
  return reduce(
    (currentValue, resolverKey) => {
      const infoSpec = resolverSpec[resolverKey];
      const firstIsPath = Array.isArray(infoSpec[0]);
      const secondIsMapperList = Array.isArray(infoSpec[1]);
      const propertyPath = firstIsPath ? (infoSpec[0] as string[]) : (infoSpec as string[]);
      const mappers = secondIsMapperList ? (infoSpec[1] as SDLContentMapper[]) : [];
      const defaultValueField =
        firstIsPath && secondIsMapperList && infoSpec[2] ? infoSpec[2] : globalDefaultValue;

      const contentValue = propOr(propertyPath, infoSource, defaultValueField);

      return {
        ...currentValue,
        [resolverKey]: pipe(...mappers)(contentValue),
      };
    },
    {},
    keys(resolverSpec),
  );
};
